import React from 'react';
import PropTypes from 'prop-types';

import { STATIC_ROOT } from '../../../../constants';
import SvgComponent from '../../../SvgComponent';
import { KycMessageContainer } from './KycMessageStyle';

const KycMessage = ({ text }) => {
    return (
        <KycMessageContainer>
            <SvgComponent src={`${STATIC_ROOT}/icon/info-circle.svg`} width={17} height={17} />
            <span>{text}</span>
        </KycMessageContainer>
    );
};

KycMessage.propTypes = {
    text: PropTypes.string.isRequired
};

export default KycMessage;



// WEBPACK FOOTER //
// ./src/components/funnel/payment-selection-step/kyc-message/KycMessage.js